module.exports = __webpack_public_path__ + "img/mci_logo.ecd6d3fb.png";